import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { of, Observable } from 'rxjs';

export namespace ContractSecondaryTextProvider {
  export class RejectionCode extends BaseAsyncValue<(option: any) => string> {
    getValue(): Observable<(option: any) => string> {
      return of(this.customSelectedLabelPicker);
    }
    customSelectedLabelPicker(option: any): string {
      return `${option.label} ${option.secondaryText ? option.secondaryText : ''}`;
    }
  }
}
